import { render, staticRenderFns } from "./StatusReservation.vue?vue&type=template&id=e8c4289c&"
import script from "./StatusReservation.vue?vue&type=script&lang=js&"
export * from "./StatusReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports